import React from 'react';
import { Grid, GridRow, GridColumn, List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
    SprayEntityIds,
    SprayApplicationRate,
    SprayProduct,
    SprayEquipmentSetId
} from 'services/sprayEvents/types';
import { UnitTypeId } from 'services/unitTypes/types';
import { AppState } from 'services/types';
import { makeSelectProductFieldValue } from 'services/products/selectors';
import { ProductId } from 'services/products/types';
import FieldValue from 'components/FieldValue';
import { isApplicationTypeNeedHalfCalculation } from 'services/sprayEvents/utils';
import ReEntryPeriodListItem from './components/ReEntryPeriodListItem';
import WithholdingPeriodListItem from './components/WithholdingPeriodListItem';
import ProductTotalListItem from './components/ProductTotalListItem';
import RatePerTankListItem from './components/RatePerTankListItem';
import RatePerHundredLitreListItem from './components/RatePerHundredLitreListItem';
import OrderIntoTankListItem from './components/OrderIntoTankListItem';
import TotalAreaListItem from './components/TotalAreaListItem';
import ProductApplicationPerOperatorLabel from './components/ProductApplicationPerOperatorLabel';

export interface OwnProps {
    product: SprayProduct;
    productId: ProductId;
    entityIds: SprayEntityIds;
    applicationRate: SprayApplicationRate;
    orderIntoTank: number;
    equipmentSetId: SprayEquipmentSetId;
}

export interface ConnectedProps {
    unitTypeId: UnitTypeId;
}

export type Props = OwnProps & ConnectedProps;

export class ProductDetailsComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const {
            product,
            productId,
            orderIntoTank,
            entityIds,
            applicationRate,
            equipmentSetId,
            unitTypeId
        } = this.props;

        return (
            <List className="product-details">
                <FieldValue name="applicationType">
                    {(applicationType: string): React.ReactElement => {
                        const needHalfCalculation =
                            isApplicationTypeNeedHalfCalculation(
                                applicationType
                            );

                        return (
                            <React.Fragment>
                                <ProductApplicationPerOperatorLabel
                                    applicationType={applicationType}
                                />
                                <Grid>
                                    <GridRow>
                                        <GridColumn
                                            mobile={8}
                                            computer={4}
                                            tablet={4}
                                        >
                                            <ProductTotalListItem
                                                productId={productId}
                                                product={product}
                                                entityIds={entityIds}
                                                unitTypeId={unitTypeId}
                                                applicationRate={
                                                    applicationRate
                                                }
                                                needHalfCalculation={
                                                    needHalfCalculation
                                                }
                                            />
                                        </GridColumn>
                                        <GridColumn
                                            mobile={8}
                                            computer={4}
                                            tablet={4}
                                        >
                                            <TotalAreaListItem
                                                productId={productId}
                                                entityIds={entityIds}
                                                needHalfCalculation={
                                                    needHalfCalculation
                                                }
                                            />
                                        </GridColumn>
                                        <GridColumn
                                            mobile={8}
                                            computer={4}
                                            tablet={4}
                                        >
                                            <RatePerTankListItem
                                                productId={productId}
                                                product={product}
                                                applicationRate={
                                                    applicationRate
                                                }
                                                equipmentSetId={equipmentSetId}
                                                unitTypeId={unitTypeId}
                                            />
                                        </GridColumn>
                                        <GridColumn
                                            mobile={8}
                                            computer={4}
                                            tablet={4}
                                        >
                                            <RatePerHundredLitreListItem
                                                productId={productId}
                                                product={product}
                                                applicationRate={
                                                    applicationRate
                                                }
                                                unitTypeId={unitTypeId}
                                            />
                                        </GridColumn>
                                    </GridRow>
                                    <GridRow>
                                        <GridColumn
                                            mobile={8}
                                            computer={4}
                                            tablet={4}
                                        >
                                            <OrderIntoTankListItem
                                                orderIntoTank={orderIntoTank}
                                            />
                                        </GridColumn>
                                        <GridColumn
                                            mobile={8}
                                            computer={4}
                                            tablet={4}
                                        >
                                            <WithholdingPeriodListItem
                                                productId={productId}
                                            />
                                        </GridColumn>
                                        <GridColumn
                                            mobile={8}
                                            computer={4}
                                            tablet={4}
                                        >
                                            <ReEntryPeriodListItem
                                                productId={productId}
                                            />
                                        </GridColumn>
                                    </GridRow>
                                </Grid>
                            </React.Fragment>
                        );
                    }}
                </FieldValue>
            </List>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    unitTypeId: makeSelectProductFieldValue('unitTypeId')
});

export default connect(mapStateToProps)(ProductDetailsComponent);
